import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminService } from '@app/service/admin.service';
import { AlertToastService } from '@app/service/alert-toast.service';
import { AuthService } from '@app/service/auth.service';
import { finalize, takeUntil } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  isLoading: boolean = false
  constructor(
    private formBuiler: FormBuilder,
    private authService: AuthService,
    private alertService: AlertToastService,
    private adminService: AdminService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.loginForm = this.formBuiler.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  loginNow() {
    this.isLoading = true;
    this.authService.adminLogin({ ...this.loginForm.value }).pipe(finalize(() => this.isLoading = false)).subscribe({
      next: (res) => {
        this.alertService.show({ message: 'Login Successfull!', type: 'success' })
        this.authService.setToken(res.accessToken)
        this.router.navigate(['/'])
      },
      error: (err) => {
        if (err && err.error) {
          this.alertService.show({ message: err.error.message, type: 'danger' })
        }
      }
    })
  }
}
